import React from 'react';

interface StatCardProps {
  title: string;
  value: number;
  description?: string;
  icon?: React.ReactNode;
}

const StatCard: React.FC<StatCardProps> = ({ title, value, description, icon }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="flex items-center">
        {icon && (
          <div className="flex-shrink-0 mr-4">
            <div className="bg-blue-100 rounded-full p-3">
              {icon}
            </div>
          </div>
        )}
        <div>
          <h3 className="text-lg font-medium text-gray-900">{title}</h3>
          <div className="mt-1">
            <p className="text-3xl font-semibold text-blue-600">
              {value.toLocaleString()}
            </p>
            {description && (
              <p className="mt-1 text-sm text-gray-500">{description}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatCard;
